import { concat, isEmpty, get, cloneDeep } from 'lodash';
import suggestionType from './Suggestion.type';
import { Page_Size } from '../../../../../Components/helper';

const initialState = {
  suggestionListData: [],
  suggestionSelectedIds: [],
  suggestionTodoList: [],
  mainSamples: [],
  section: [
    { value: 'bom', label: 'Bill of Materials' },
    { value: 'testing', label: 'Testing' },
    { value: 'measurement', label: 'Measurements' },
    { value: 'care-label', label: 'Care Labels' },
  ],

  suggestionFilterValues: {
    selectedSuggestion_Season: [],
    selectedSuggestion_Year: [],
    selectedSuggestion_Brand: [],
    selectedSuggestion_Supplier: [],
    selectedSuggestion_Type: '',
    selectedSuggestion_Category1: [],
    selectedSuggestion_Category2: [],
    selectedSuggestion_Category3: [],
    selectedSuggestion_Category4: [],
    selectedSuggestion_Section: '',
    selectedSuggestion_Status: '',
    selectedLicensor: [],
    selectedLicense: [],
    selectedLikeness: [],
    searchText: '',
    pageIndex: 1,
    pageSize: Page_Size,
    sortOrder: '',
    sortPropertyName: '',
    loading: false,
  },
  suggestionListTotalCount: 0,
  currentRequestId: null,
};

const suggestionTodoListReducer = (state = initialState, action) => {
  switch (action.type) {
    case suggestionType.SET_SUGGESTION_REQUESTS_TODOLIST: {
      if (
        action.payload.requestId &&
        state.currentRequestId &&
        Number(action.payload.requestId) < Number(state.currentRequestId)
      ) {
        return state;
      }
      const updatedArry = cloneDeep(setArrayByCase(state.suggestionListData, action.payload));
      return {
        ...state,
        suggestionListData: updatedArry,
        suggestionListTotalCount: action.payload.totalCount,
        currentRequestId: action.payload.requestId || state.currentRequestId,
      };
    }
    case suggestionType.SET_SELECTED_IDS_ARRAY:
      return {
        ...state,
        suggestionSelectedIds: action.payload,
      };
    case suggestionType.SET_FILTER_SORT_DATA:
      return {
        ...state,
        suggestionFilterValues: {
          ...state.suggestionFilterValues,
          ...action.payload,
        },
      };
    case suggestionType.GET_MAIN_SAMPLES:
      return {
        ...state,
        mainSamples: action.payload,
      };
    default:
      return state;
  }
};

const setArrayByCase = (array, payload) => {
  if (!isEmpty(get(payload, 'searchText')) && get(payload, 'isScrolled')) {
    array = [...array, ...payload.data];
    return array;
  }
  if (!isEmpty(get(payload, 'searchText'))) {
    array = payload.data;
    return array;
  }
  if (get(payload, 'isScrolled')) {
    array = concat(array, payload.data);
    return array;
  }
  return payload.data;
};

export default suggestionTodoListReducer;
